import { createActions } from 'redux-actions'

export const { offline }: any = createActions({
  OFFLINE: {
    /** handled by actionCreators helper @see store/actionCreators/createRequestActions */
    REQUEST: (actionType, params) => ({ actionType, params }),
    START_WAITING: action => ({ action }),
    /** handle by saga, @see store/entities/offline/saga/addToWaiting */
    ADD_TO_WAITING: action => ({ action }),
    /** handle by saga, @see store/entities/offline/saga/shiftFirst */
    SHIFT_FIRST: undefined,
    SET_OFFLINE: isOffline => ({ isOffline }),
  },
})
